import React from 'react';
import BaseActionListItem from './index';
const ActionListItem = (props) => <BaseActionListItem {...props} />;

export default ActionListItem;
